'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import timerCountdown from '../../utils/timerCountdown.js';
import { recaptchaUpdater } from '../../modules/recaptcha';

const appAccessCode = {
  bindActions() {
    $('.o-btn--access-code').on('click', e => {
      e.preventDefault();

      const $btn = $(e.currentTarget);
      var post = {};

      post.cpf = $('input[name="cpf"]').val();
      post._token = $('meta[name="csrf-token"]').attr('content');

      var url = '/entrar/codigo-de-acesso';

      $.ajax({
        type: 'POST',
        url: url,
        data: post,
        dataType: 'json',
        success: function (data) {
          console.log($btn);
          if (data.success) {
            $btn.prop('disabled', true);

            setTimeout(() => {
              $btn.prop('disabled', false);
            }, 120000);

            timerCountdown('timer', 2);

            $('#send-block').removeClass('u-display--none');

            Swal.fire({
              type: 'success',
              title: data.title,
              html: data.message,
              icon: 'success',
            });
          } else {
            Swal.fire({
              type: 'error',
              title: data.title,
              text: data.message,
              icon: 'error',
            });
          }
        },
      });
    });
  },

  init() {
    recaptchaUpdater('login');
    _this.bindActions();
  },
};

const s = appAccessCode.settings,
  _this = appAccessCode;

export default _this;
